const coin = {};

const pearl = {
  amountPlaceholder: 'أدخل المبلغ المراد إرساله',
};

export default {
  shippingCoin: 'عملة الشحن',
  level: 'LV{{num}}',
  pearl2coins: '{{pearl}} لؤلؤة = {{coin}} عملات ذهبية',
  confirmTips: 'يرجى التحقق من المعرف والمبلغ الذي تريد إرساله',
  inputAmountTips: 'أدخل المبلغ الذي تريد إرساله',
  resultTitle: 'للعملة ذهبية',
  successTitle: 'إرسال بنجاح',
  successContent: 'لقد استلم المستلم العملة الذهبية وسيتلقى رسالة آلية منك',
  failureContent:
    'المعاملات الحالية غير طبيعية، يرجى الانتقال إلى تفاصيل المعاملات للتحقق من النتائج',
  pearlConfirmTips: 'يرجى التحقق من المبلغ الذي تريد استبداله (رصيد اللؤلؤة {{num}})',
  coin,
  pearl,
};
